import { Stack, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";

import { ModelCardFragment } from "../../models.graphql";

interface ModelCardContentCreatorProps {
  model: ModelCardFragment;
}

const WorkspaceLogo = styled("img")(() => ({
  height: 16,
  width: 16,
  borderRadius: 4,
}));

export const ModelCardContentCreator = (
  props: ModelCardContentCreatorProps,
) => {
  const { model } = props;

  const theme = useTheme();

  const workspaceDisplay = `${model.workspace?.displayName}`;

  return (
    <Stack direction="row" gap={2} sx={{ alignItems: "center" }}>
      {model.workspace?.profilePicture && (
        <WorkspaceLogo
          alt={model.workspace.displayName}
          src={model.workspace.profilePicture}
        />
      )}
      <Typography
        sx={{ textShadow: `1px 1px 3px ${theme.palette.secondary[6]}` }}
        variant="caption"
      >
        {workspaceDisplay}
      </Typography>
    </Stack>
  );
};
